import useSWR from 'swr';
import { getRequest, postRequest, patchRequest, deleteRequest } from '../utils/request';

export const getInventories = async (queryParams) => getRequest(`/inventory`, queryParams);
export const GetInventories = queryParams => useSWR(() => !queryParams?.revoke ? [`/inventory`, queryParams] : null, getRequest)
export const GetInventoriesForServiceSlip = queryParams => useSWR(() => queryParams?.revoke || !queryParams?.branch ? null : [`/inventory/service-slip`, queryParams], getRequest)

export const getInventoryById = async (id) => getRequest(`/inventory/${id}`);

export const GetInventoryById = id => useSWR(() => id ? `/inventory/${id}` : null, getRequest)

export const getInventoryByProductId = async (productId, branch) => getRequest(`/inventory/product/${productId}`, { branch });
export const GetInventoryByProductId = (productId, branch) => useSWR(() => productId ? [`/inventory/product/${productId}`, { branch }] : null, getRequest)

export const postInventory = async (data) => postRequest(`/inventory`, data);

export const patchInventory = async (id, data) => patchRequest(`/inventory/${id}`, data);

export const deleteInventory = async (id) => deleteRequest(`/inventory/${id}`);


export const uploadDeliveryImages = async (id, data) => postRequest(`/inventory/upload-images/${id}`, data);
export const deleteDeliveryFile = async (id, fileId) => deleteRequest(`/inventory/upload-images/${id}/${fileId}`);


export const exportInventoryEvents = async (queryParams) => getRequest(`/inventory/inventory-events/export`, queryParams);